app.service('moneyService', [
  'mainConfig',
  function (mainConfig) {
    function centsToDollars(cents, currencyIso) {
      var precision = getPrecision(currencyIso);
      var multiplier = Math.pow(10, precision + 1);
      var wholeNumber = Math.floor(
        (parseFloat(cents) / Math.pow(10, precision)) * multiplier,
      );
      return (Math.round(wholeNumber / 10) * 10) / multiplier;
    }

    function dollarsToCents(dollars, currencyIso) {
      var precision = getPrecision(currencyIso);
      var multiplier = Math.pow(10, precision);
      return dollars * multiplier;
    }

    function centsToMoney(cents, currencyIso, symbol, symbol_first) {
      return toMoney({
        cents: cents,
        currencyIso: currencyIso,
        symbol: symbol,
        symbol_first: symbol_first,
      });
    }

    function toMoney(data) {
      var baseCurrency = mainConfig.merchantData.base_currency;
      data = angular.extend(
        {
          cents: 0,
          symbol: baseCurrency.alternate_symbol,
          symbol_first: baseCurrency.symbol_first,
          currencyIso: baseCurrency.iso_code,
          withPrecision: true,
        },
        data,
      );
      if (data.dollars === undefined) {
        // Calculate dollars by cents
        data.dollars = centsToDollars(data.cents, data.currencyIso);
      }
      var labelValue = data.dollars;
      var precision = 0;
      if (data.withPrecision) {
        precision = getPrecision(data.currencyIso);
      }
      if (labelValue.toFixed !== undefined) {
        labelValue = labelValue.toFixed(precision);
      }
      labelValue = labelValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      data.label = data.symbol_first
        ? data.symbol + labelValue
        : labelValue + ' ' + data.symbol;
      return data;
    }

    function getPrecision(currencyIso) {
      if (
        currencyIso === 'TWD' ||
        currencyIso === 'JPY' ||
        currencyIso === 'VND'
      ) {
        return 0;
      } else {
        return 2;
      }
    }

    function getMultiplier(currencyIso) {
      return Math.pow(10, getPrecision(currencyIso));
    }

    function bankersRound(num, decimalPlaces) {
      // following implementation is from stackoverflow
      // https://stackoverflow.com/questions/3108986/gaussian-bankers-rounding-in-javascriptg
      const d = decimalPlaces || 0;
      const m = Math.pow(10, d);
      const n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
      const i = Math.floor(n);
      const f = n - i;
      const e = 1e-8; // Allow for rounding errors in f
      const r =
        f > 0.5 - e && f < 0.5 + e ? (i % 2 === 0 ? i : i + 1) : Math.round(n);
      return d ? r / m : r;
    }

    return {
      centsToDollars: centsToDollars,
      dollarsToCents,
      centsToMoney: centsToMoney,
      getPrecision: getPrecision,
      getMultiplier: getMultiplier,
      toMoney: toMoney,
      bankersRound,
    };
  },
]);
